import React from 'react';
import { BookOpenIcon, BrainIcon, FlameIcon, TrophyIcon, StarIcon, BookIcon, CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
import { Button } from '../ui/Button';
export const Content: React.FC = () => {
  const features = [{
    icon: <BookOpenIcon className="w-6 h-6 text-[#E0B84C]" data-id="element-42" />,
    title: 'La travesía completa',
    description: 'De Madeira al mundo',
    badge: 'EXCLUSIVO'
  }, {
    icon: <BrainIcon className="w-6 h-6 text-[#E0B84C]" data-id="element-43" />,
    title: 'Mentalidad de campeón',
    description: 'Disciplina, hambre, constancia',
    badge: 'PREMIUM'
  }, {
    icon: <TrophyIcon className="w-6 h-6 text-[#E0B84C]" data-id="element-44" />,
    title: 'Momentos inmortales',
    description: 'Manchester, Madrid, Lisboa...'
  }, {
    icon: <StarIcon className="w-6 h-6 text-[#E0B84C]" data-id="element-45" />,
    title: '9 figuras coleccionables',
    description: 'Ilustración original',
    badge: 'LIMITADO'
  }, {
    icon: <CheckCircleIcon className="w-6 h-6 text-[#E0B84C]" data-id="element-46" />,
    title: 'Certificado de edición limitada',
    description: 'Numerado y personalizado',
    badge: 'NUMERADO'
  }, {
    icon: <FlameIcon className="w-6 h-6 text-[#E0B84C]" data-id="element-47" />,
    title: 'Acceso inmediato',
    description: 'Multiplataforma'
  }];
  return <section className="py-20 pb-12 relative" data-id="element-48">
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-px h-full bg-gradient-to-b from-transparent via-[#E0B84C]/30 to-transparent" data-id="element-49"></div>
      <div className="text-center mb-16 relative z-10" data-id="element-50">
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-51">
          Este no es un producto oficial. Es algo más{' '}
          <span className="text-[#E0B84C]" data-id="element-52">poderoso</span>.
        </h2>
        <p className="text-lg text-[#CFCFCF] max-w-3xl mx-auto" data-id="element-53">
          Una creación hecha por fans obsesionados. Por sus noches imposibles.
          Por su mentalidad inquebrantable. Por su forma de convertir lo humano
          en sobrehumano.
        </p>
        <p className="text-lg text-[#CFCFCF] max-w-3xl mx-auto mt-4" data-id="element-54">
          Diseñada con intención. Curada como un tesoro. Limitada como una obra
          de arte.
        </p>
        <p className="text-lg text-[#E0B84C] font-medium mt-6" data-id="element-55">
          Solo los verdaderos fans saben que… cuando se agotan, no vuelven
          jamás.
        </p>
      </div>
      <div className="mt-16" data-id="element-56">
        <div className="flex items-center justify-center mb-10" data-id="element-57">
          <div className="bg-[#0A0A0A] border border-[#E0B84C]/30 rounded-full px-6 py-2" data-id="element-58">
            <h3 className="text-2xl font-bold flex items-center" data-id="element-59">
              <BookIcon className="w-6 h-6 text-[#E0B84C] mr-2" data-id="element-60" /> ¿QUÉ INCLUYE?
            </h3>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-61">
          {features.map((feature, index) => <div key={index} className="p-6 bg-gradient-to-b from-[#1A1A1A] to-[#0A0A0A] border border-[#E0B84C]/20 rounded-xl hover:border-[#E0B84C]/50 transition-all duration-300 group" data-id="element-62">
              <div className="w-12 h-12 bg-[#0A0A0A]/50 rounded-full flex items-center justify-center mb-4 border border-[#E0B84C]/30 group-hover:bg-[#0A0A0A] group-hover:border-[#E0B84C]/60 transition-all duration-300" data-id="element-63">
                {feature.icon}
              </div>
              <div className="flex items-center gap-2 mb-2" data-id="element-64">
                <h4 className="text-xl font-bold" data-id="element-65">{feature.title}</h4>
                {feature.badge && <span className="text-xs bg-[#E0B84C]/10 text-[#E0B84C] px-2 py-0.5 rounded-full" data-id="element-66">
                    {feature.badge}
                  </span>}
              </div>
              <p className="text-gray-400" data-id="element-67">{feature.description}</p>
            </div>)}
        </div>
        <div className="mt-10 flex justify-center" data-id="element-68">
          <Button className="text-sm py-2.5 px-8 flex items-center justify-center gap-2 transform hover:scale-105 transition-all duration-300 shadow-lg" href="https://store.collectiondigital.vip/cart/45861496684706:1" data-id="element-69">
            <FlameIcon className="w-4 h-4 text-yellow-300" data-id="element-70" />
            <span data-id="element-71">DESCARGAR AHORA</span>
            <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-72" />
          </Button>
        </div>
      </div>
    </section>;
};